import { h, Fragment } from "preact";
import { useState, useContext } from "preact/hooks";
import { SimpleReferralWidgetContext } from "../index";
import {
  calculateForeground,
  traceWidgetLoad
} from "../../../internal_utilities/utilities";
import GiftIcon from "../../../_components/Icons/GiftIcon";
import HighlightedTitle from "../../../_components/HighlightedTitle";
import SignUpForm from "./SignUpForm";
import HowItWorks from "./HowItWorks";

const CashbackView = props => {
  const simpleReferralWidgetContext = useContext(SimpleReferralWidgetContext);
  const [isFormVisible, setIsFormVisible] = useState(false);

  const highlightColor = simpleReferralWidgetContext.currentCampaign
    .thankyouPageConfig.popupThemeColor
    ? simpleReferralWidgetContext.currentCampaign.thankyouPageConfig
        .popupThemeColor
    : simpleReferralWidgetContext.currentCampaign.thankyouPageConfig.bgEndColor;

  const offerViewTitleWordMap = [
    {
      placeholder: "<gift_offer>",
      value: `${simpleReferralWidgetContext.currentCampaign.giftConfig
        .discountValue * -1}${
        simpleReferralWidgetContext.currentCampaign.giftConfig.discountType ===
        "percentage"
          ? "%"
          : ` ${window.Shopify.currency.active}`
      }`
    },
    {
      placeholder: "<maximum_reward>",
      value: `${simpleReferralWidgetContext.currentCampaign.rewardConfig
        .rewardValue * -1}${
        simpleReferralWidgetContext.currentCampaign.rewardConfig
          .rewardDimension === "percentage"
          ? "%"
          : ` ${window.Shopify.currency.active}`
      }`
    },
    {
      placeholder: "<maximum_cashback>",
      value: `${simpleReferralWidgetContext.currentCampaign.rewardConfig
        .rewardValue * -1}${
        simpleReferralWidgetContext.currentCampaign.rewardConfig
          .rewardDimension === "percentage"
          ? "%"
          : ` ${window.Shopify.currency.active}`
      }`
    }
  ];

  return (
    <Fragment>
      <div id="coca-offer-view-details" className=" grow overflow-y-auto p-6">
        <div className="flex justify-center mt-2  ">
          <div id="coca-popup-icon" className=" w-16 h-auto">
            <GiftIcon color={highlightColor} />
          </div>
        </div>
        <h1
          id="coca-referral-hero-text"
          className=" font-bold text-2xl text-center p-2"
        >
          {simpleReferralWidgetContext.currentLanguage &&
          simpleReferralWidgetContext.currentLanguage.cashback_view_title ? (
            <HighlightedTitle
              color={highlightColor}
              text={
                simpleReferralWidgetContext.currentLanguage.cashback_view_title
              }
              wordMap={offerViewTitleWordMap}
            />
          ) : (
            <span>
              Gift your friends{" "}
              <span
                ref={node => {
                  if (node) {
                    node.style.setProperty(
                      "background",
                      `${highlightColor}`,
                      "important"
                    );
                    node.style.setProperty(
                      "color",
                      `${
                        calculateForeground(highlightColor) === "white"
                          ? "rgba(255,255,255,1)"
                          : "rgba(0,0,0,.6)"
                      }`,
                      "important"
                    );
                  }
                }}
                className="coca-referral-hero-highlight rounded-lg p-1"
              >
                {simpleReferralWidgetContext.currentCampaign.giftConfig
                  .discountValue * -1}
                {simpleReferralWidgetContext.currentCampaign.giftConfig
                  .discountType === "percentage"
                  ? "%"
                  : ` ${window.Shopify.currency.active}`}
              </span>{" "}
              discount coupon and get cashback upto{" "}
              <span
                ref={node => {
                  if (node) {
                    node.style.setProperty(
                      "background",
                      `${highlightColor}`,
                      "important"
                    );
                    node.style.setProperty(
                      "color",
                      `${
                        calculateForeground(highlightColor) === "white"
                          ? "rgba(255,255,255,1)"
                          : "rgba(0,0,0,.6)"
                      }`,
                      "important"
                    );
                  }
                }}
                className="coca-referral-hero-highlight rounded-lg p-1"
              >
                {`${simpleReferralWidgetContext.currentCampaign.rewardConfig
                  .rewardValue * -1}${
                  simpleReferralWidgetContext.currentCampaign
                    .rewardDimension === "percentage"
                    ? "%"
                    : ` ${window.Shopify.currency.active}`
                }`}
              </span>{" "}
            </span>
          )}
        </h1>
        <HowItWorks rewardType="cashback" />
      </div>

      <div
        id="corner-referral-pop-up-initial-cta-wrapper"
        className=" px-4 py-3 font-bold grow-0 shrink-0 flex"
      >
        <a
          onClick={() => {
            traceWidgetLoad({
              name: "clicked_offerview_cta",
              domain: window.Shopify.shop,
              url: window.location.href,
              referrer: document.referrer || "",
              key: ["app_name", "widget_type"],
              value: [
                "offerscorner",
                simpleReferralWidgetContext.currentCampaign.type
              ],
              operatingSystem: window.navigator.userAgentData
                ? window.navigator.userAgentData.platform
                : window.navigator.platform,
              screenSize: window.screen
                ? `${window.screen.width}-${window.screen.height}`
                : "",
              browserVersion: window.navigator.userAgentData
                ? window.navigator.userAgentData.brands[0].version
                : "",
              browser: window.navigator.userAgentData
                ? window.navigator.userAgentData.brands[0].brand
                : ""
            });
            setIsFormVisible(true);
          }}
          id="corner-referral-pop-up-initial-cta-text"
          className="coca-thank-big-button p-4 rounded-md text-center cursor-pointer text-base w-full grow"
          ref={node => {
            if (node)
              node.style.setProperty(
                "background",
                `${highlightColor}`,
                "important"
              );
          }}
          type="submit"
        >
          <span
            ref={node => {
              if (node)
                node.style.setProperty(
                  "color",
                  `${
                    calculateForeground(highlightColor) === "white"
                      ? "rgba(255,255,255,1)"
                      : "rgba(0,0,0,.6)"
                  }`,
                  "important"
                );
            }}
          >
            {" "}
            {simpleReferralWidgetContext.currentLanguage &&
            simpleReferralWidgetContext.currentLanguage.offer_view_cta
              ? simpleReferralWidgetContext.currentLanguage.offer_view_cta
              : "Get this offer"}
          </span>
        </a>
      </div>
      <SignUpForm
        isFormVisible={isFormVisible}
        onClose={() => setIsFormVisible(false)}
      />
    </Fragment>
  );
};

export default CashbackView;
